<template>
  <div>
    <div class="workOrder_info">
      <div class="left">
        <p>护送到手术间: {{ this.info.deskName }}</p>
        <p>护送到手术间: {{ this.info.tranferDeskName }}</p>

        <p>
          病人名称:
          {{ this.info.patientName == null ? "无" : this.info.patientName }}
        </p>
        <p>护工名称: {{ this.info.nursingName }}</p>
      </div>

      <div class="center" v-show="this.info.state == 3 ? true : false">
        <el-steps :active="5" align-center>
          <el-step title="发布"
                   :description="this.info.createTime"
                   icon="el-icon-add-location"
          ></el-step>
          <el-step
              title="响应时间"
              :description="responseTime"
              icon="el-icon-time"
              style="color: red"
          ></el-step>
          <el-step
              title="转运"
              :description="this.info.orderTransferTime"
              icon="el-icon-refresh-right"
          ></el-step>
          <el-step
              title="处理时间"
              :description="handlingTime"
              icon="el-icon-time"
          ></el-step>
          <el-step title="到达"
                   :description="this.info.orderFinishTime"
                   icon="el-icon-circle-check"
          ></el-step>
        </el-steps>
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="this.info.state === 1 ">待转运</h1>
        <h1 class="common_color2" v-if="this.info.state === 2">转运中</h1>
        <h1 class="common_color3" v-if="this.info.state === 3">
          {{ handlingTime2 }}
        </h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="block">
      <el-timeline>
        <!-- 待转运 -->
        <div v-if="this.info.state === 1">
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
              color="#409eff"
          >
            <el-card>
              <h3>发布转运</h3>
              <span>发布时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p v-show="this.info.nursingName == null ? false : true">
                护工名称: {{ this.info.nursingName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 处理中 -->
        <div v-if="this.info.state === 2">
          <el-timeline-item
              :timestamp="this.info.orderTransferTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>转运中</h3>
              <span>转运时间: {{ this.info.orderTransferTime }}</span>
              <p style="height: 10px"></p>
              <p>{{ this.info.nursingName }}转运中</p>
              <div v-for="item in sysNursingTranferList" :key="item">
                <div  v-show="item.state == 2 ? true : false">
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="url"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      :preview-src-list="urls"
                      v-show="url? true : false"
                  >
                  </el-image>
                </div>
              </div>
              <span v-show="this.info.state == 2 ? true : false"
              >{{ this.info.nursingName }}修改状态为转运中</span
              >
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>发布转运</h3>
              <span>发布时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p v-show="this.info.nursingName == null ? false : true">
                护工名称: {{ this.info.nursingName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 已完成 -->
        <div v-if="this.info.state === 3">
          <el-timeline-item
              :timestamp="this.info.orderFinishTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>转运完成</h3>
              <span>到达时间: {{ this.info.orderFinishTime }}</span>
              <p style="height: 10px"></p>
              <div v-for="item in sysNursingTranferList" :key="item">
                <div v-show="item.state == 3 ? true : false">
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="urlCompleted"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      :preview-src-list="urlCompleteds"
                      v-show="urlCompleted ? true : false"
                  >
                  </el-image>
                </div>
              </div>
              <p style="fontsize: 20px">
                {{ this.info.nursingName }}已完成转运
              </p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item :timestamp="this.info.orderTransferTime" placement="top">
            <el-card>
              <h3>转运中</h3>
              <span>转运时间: {{ this.info.orderTransferTime }}</span>
              <p style="height: 10px"></p>
              <div v-for="item in sysNursingTranferList" :key="item">
                <div v-show="item.state == 2 ? true : false">
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="url"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      :preview-src-list="urls"
                      v-show="url ? true : false"
                  >
                  </el-image>
                </div>
              </div>
              <span>{{ this.info.nursingName }}修改状态为转运中</span>
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>发布转运</h3>
              <span>发布时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>

              <p v-show="this.info.nursingName == null ? false : true">
                转运人: {{ this.info.nursingName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>
      </el-timeline>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import {IMAGE_HOST} from "../../../config";

export default {
  name: "orderInfo",
  components: {ElImageViewer},
  props: {
    kv: null,
    id: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) {
    },
  },
  data() {
    return {
      text: "",
      mname: "work",
      url: "",
      urls: [],
      urlCompleteds: [],
      urlCompleted: "",
      items: [], // 显示条目
      info: {},
      imgUrl: "",
      sendTypeName: "",
      imgVisible: false,
      imgVisibles: false,
      list: [],
      data1: [],
      data2: [],
      total: this.total,
      imgUrls: [],
      showViewer: false,
      guidePic: null, // 预览图片的地址
      oldname: "", //原维修员名字
      newname: "", //新维修员名字
      remark: "", //转单结果
      createTime: "", //转单时间
      updateTime: "", //接受转单时间
      block: false,
      sysNursingTranferList: [], //维修记录
      maintainerName: "",
      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
    };
  },
  created() {
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
  },
  mounted() {
  },
  methods: {
    showViewerClose() {
      this.showViewer = false;
    },
    getPreview() {
      this.guidePic
          ? (this.showViewer = true)
          : this.$message.info("当前没有可预览的图片");
    },
    playMusic(type) {
      this.$refs.audio.currentTime = 0; //从头开始播放
      this.$refs.audio.play(); //播放
      setTimeout(() => {
        this.$refs.audio.pause(); //停止
      }, 3000);
    },
    initItems() {
      return this.items;
    },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = this.kv;
        $utils.api.load(`/admin/system/nursing/nusingTranferById/${id}`, {}).then((res) => {
          if (res && res.data) {

            this.info = res.data;
            this.maintainerName = res.data.maintainerName;
            this.responseTime = this.computingTime(
                this.info.createTime,
                this.info.orderTransferTime
            );
            this.handlingTime = this.computingTime(
                this.info.orderTransferTime,
                this.info.orderFinishTime
            );
            this.handlingTime2 = this.computingTime(
                this.info.createTime,
                this.info.orderFinishTime
            );

            let maintainerId = this.info.maintainerId;

            let arr2 = this.info.sysNursingTranferList; //维修记录
            this.sysNursingTranferList = arr2;
            if (arr2.length == 0) {

            } else {
              for (let i = 0; i < arr2.length; i++) {
                if (arr2[i].nursingImg) {
                  if (arr2[i].state == 2){
                    var list = [];
                    var imager = ""
                    //判断图片路径中是否含有“null”字符串
                    if (arr2[i].nursingImg.indexOf("null") != -1) {
                      //如果有的话就去除
                      imager = arr2[i].nursingImg.replace("null", "")
                    } else {
                      //如果没有就正常赋值
                      imager = arr2[i].nursingImg
                    }
                    list.push(IMAGE_HOST + imager);
                    this.urls = list;
                    this.url = this.urls[0];
                  }else{
                    var listC = [];
                    var imagerC = ""
                    //判断图片路径中是否含有“null”字符串
                    if (arr2[i].nursingImg.indexOf("null") != -1) {
                      //如果有的话就去除
                      imagerC = arr2[i].nursingImg.replace("null", "")
                    } else {
                      //如果没有就正常赋值
                      imagerC = arr2[i].nursingImg
                    }
                    listC.push(IMAGE_HOST + imagerC);
                    this.urlCompleteds = listC;
                    this.urlCompleted = this.urlCompleteds[0];
                  }

                }
              }
            }
          }
        });
    },

    changePage(p) {
      this.load(this.workId, p);
    },
    changePagesize(psize) {
    },
    showImg(src) {
      this.imgUrl = this.info.qrCode;
      this.imgVisible = true;
    },
    showImgs(src) {
      // this.imgUrl = this.imgUrls;
      this.imgVisibles = true;
    },

    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数

      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },

  },
};
</script>
<style lang="less" scoped>
.workOrder_info {
  width: 100%;
  background: #fff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 17%;
  }

  .center {
    width: 65%;

    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }

    .elp1 {
      left: 44.875rem;
    }

    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.block {
  margin-top: 30px;

  p,
  span {
    font-size: 16px;
  }
}

.divider {
  margin: 0;
}
</style>
